// The claim service sends the four-character text "null" when a claim's benefit cannot be
// resolved. It is a truthy string, and JSON.parse turns it into null, which callers then
// dereference. Malformed JSON still throws so that a different bug is not swallowed.
export const parseJsonObject = (jsonText: string | null | undefined): Record<string, any> => {
  if (!jsonText) return {}

  return JSON.parse(jsonText) ?? {}
}
